var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5716 23.3332L14.083 20.9418L11.5459 22.6799L9.00681 20.9408L6.46776 22.678L3.92395 20.9389L0.428711 23.3332V3.42843C0.428711 2.67067 0.729731 1.94395 1.26555 1.40813C1.80137 0.872309 2.52809 0.571289 3.28586 0.571289L14.7144 0.571289C15.4722 0.571289 16.1989 0.872309 16.7347 1.40813C17.2706 1.94395 17.5716 2.67067 17.5716 3.42843V23.3332ZM3.92395 18.6304L6.46681 20.3694L9.00681 18.6304L11.5459 20.3694L14.084 18.6294L15.6668 19.7142V3.42843C15.6668 3.17585 15.5665 2.9336 15.3879 2.755C15.2093 2.57639 14.967 2.47605 14.7144 2.47605H3.28586C3.03327 2.47605 2.79103 2.57639 2.61242 2.755C2.43381 2.9336 2.33347 3.17585 2.33347 3.42843V19.7142L3.92395 18.6304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reports-icon.a78627db8fc177e87c9b1864b810b2ff.svg";
export { ForwardRef as ReactComponent };